import React, { useEffect } from 'react';

const MobileOverlay = ({ isOpen, onClick }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-background z-40 lg:hidden"
      onClick={onClick}
      aria-hidden="true"
    />
  );
};

export default MobileOverlay;